import { render, staticRenderFns } from "./SvTabs.vue?vue&type=template&id=34d37d19&scoped=true&lang=pug&"
import script from "./SvTabs.vue?vue&type=script&lang=js&"
export * from "./SvTabs.vue?vue&type=script&lang=js&"
import style0 from "./SvTabs.vue?vue&type=style&index=0&id=34d37d19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d37d19",
  null
  
)

export default component.exports